import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment-timezone";
import { BehaviorService } from "src/app/services/behaviour.service";
import { CommonService } from "src/app/services/common.service";
declare var $: any;

@Component({
  selector: "app-age-verify",
  templateUrl: "./age-verify.component.html",
  styleUrls: ["./age-verify.component.css"],
})
export class AgeVerifyComponent implements OnInit {
  storeMobile: any;
  addressString = "";
  ageVerification: any;
  servicesOption: any = [];
  pickUpStoreList: any;
  pickupStoreListInThisRegion: any;
  loader: boolean = false;
  pickupAddress: any;
  auth: any;
  userId: any;
  userName: any;
  selectedStoreImage: any = "";
  storeId: any;
  storeName: any;
  storeAccountNum: any;
  authorization: any;
  latitude_new: number;
  longitude_new: number;
  selectedStoreAddress: string;
  bgImage: any = "";
  siteDada: any = "";
  ageVerify: any;
  weekday: any = "";
  logoImage;
  selectedStoreName: any;
  pickopenHour;
  delOpenHour;
  constructor(
    private router: Router,
    private commonService: CommonService,
    private _bs: BehaviorService
  ) {

    // let ageVerify: any = localStorage.getItem('ageVerify')
    // if (ageVerify == true || ageVerify == 'true') {
    //   this.router.navigateByUrl('/')
    // }
   let refreshVar:any= this._bs.getSiteData().subscribe((res) => {
      if (res == true) {
        this.ngOnInit();
        this.loader = true;
        refreshVar.unsubscribe()
      } else {
        this.loader = false;
      }
    });
  }

  ngOnInit(): void {    
    this.weekday = new Date().toLocaleString("en-us", { weekday: "long" });
    this.ageVerify = localStorage.getItem("ageVerify");
    if (this.ageVerify == true || this.ageVerify == "true") {
      localStorage.setItem("ageVerify", "true");
      $("#SearchLocation").modal("show");
    }   

    this.getStoreDetail()
    setTimeout(() => {
      let siteDada = JSON.parse(localStorage.getItem("siteData"));
      if (siteDada != null) {
        this.siteDada = siteDada;
        this.logoImage = this.siteDada?.footerLogo?.url;
      }
    }, 1000);

    this.getData();
    if (this.siteDada != null) {
      this.selectedStoreName = localStorage.getItem("localStoreName");
      this.selectedStoreAddress = localStorage.getItem("addressString");
         localStorage.setItem("isSwitch", "false");
      this.getLogin();

      this.commonService.pickUpStore("").subscribe((res) => {
        this.pickUpStoreList = res;
        localStorage.setItem('stores',this.pickUpStoreList?.length)
        let weekday = new Date().toLocaleString("en-us", { weekday: "long" });

        if (this.storeDetails && this.storeDetails["StoreHours"] && this.storeDetails["DeliveryHours"][weekday]) {
          let a = this.storeDetails["StoreHours"][weekday];
          let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
          var currentTime = moment(new Date());
          var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
          var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute;
          var beginningTime = moment(StoreOpenTime, "HH:mm");
          var endTime = moment(StoreCloseTime, "HH:mm");
          if (currentTime > beginningTime && currentTime < endTime) {
            this.StoreClosed = false;
          } else {
            this.StoreClosed = true;
          }
          if (a) {
            this.dilverytime = dilveryHoursObj;
            localStorage.setItem("storeTiming", JSON.stringify(a));
          }
        }
      });
    }
  }

  getData() {
    this.commonService.Get("/websitesetup/ageverification").subscribe((res) => {
      if (res["meta"]["status"]) {
        if (res?.homePageContent != null) {
          if (res?.homePageContent?.ageVerification) {
            this.ageVerification = res?.homePageContent?.ageVerification;
            this.bgImage = res?.homePageContent?.ageVerification?.bgImage;
            if (this.bgImage == "" || this.bgImage == undefined || this.bgImage == null) {
              this.bgImage = "assets/images/bg1.jpg";
            }
          }
        }
      }
    });
  }

  getLogin() {
    const formData = new FormData();
    formData.append("grant_type", "password");
    formData.append("username", "CannaLogic.COVA.APIUser.COVACafe");
    formData.append("password", "sevenstar@7#");
    formData.append("client_id", "COVACafe.CannaLogic");
    formData.append("client_secret", "iwH2N70bE23IHUD91f39WtO9");
    this.commonService.loginCredential(formData).subscribe((res) => {
      localStorage.setItem("covatoken", res["access_token"]);
    });
  }

  verifyAge(status) {
    if (!status) {
    } else {
      localStorage.setItem("ageVerify", status);
    }
  }




  updatePickUpStoreData(storeId, storeName, storeAccountNum, authorization, addressLine1, addressLine2, city, state, stateCode, country, countryCode, zip, addressObj, lat, long, statusCalled, list) {
    localStorage.setItem("storeInfo", JSON.stringify(list));

    var pickupStatus = "false";
    if (statusCalled) {
      this.pickupAddress = list?.AddressLine2;
      pickupStatus = "false";
    }
    this.pickupAddress = list?.Address?.AddressLine2;
    localStorage.setItem("localStoreId", storeId);
    localStorage.setItem("storeCurrentAddress", this.pickupAddress);
    localStorage.setItem("addressString", this.pickupAddress);
    localStorage.setItem("addressForOrderPlace", addressLine2);
    localStorage.setItem("addressStatus", "true");
    localStorage.setItem("addressLatitude",lat);
    localStorage.setItem("addressLongitude",long);
    localStorage.setItem("postal_code", zip);
    localStorage.setItem("city", city);
    localStorage.setItem("state", state);
    localStorage.setItem("stateCode", stateCode);
    localStorage.setItem("country", country);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem("dilveryStatus", "true");
    localStorage.setItem("localStoreName", storeName);
    localStorage.setItem("isPickUpOrder", pickupStatus), localStorage.setItem("storeAccountNum", storeAccountNum), localStorage.setItem("authorization", authorization);
 
    this.userId = localStorage.getItem("covaUserId");
    this.userName = localStorage.getItem("userName");
    let obj = {
      CustomerId: this.userId,
      AddressTypeId: 2,
      AttentionTo: this.userName,
      CountryCode: countryCode,
      Default: false,
      DoNotContact: true,
      Email: "",
      Locality: "",
      Notes: "",
      Phone: "",
      PostalCode: zip,
      PostOfficeBoxNumber: "",
      StateCode: stateCode,
      StreetAddress1: addressLine1,
      StreetAddress2: addressLine2,
      currentLat: lat,
      currentLong: long,
      formattedAddress: this.pickupAddress,
    };
    if (this.auth) {
      this.commonService.saveAddress(obj).subscribe((res) => {
        this._bs.routerData("reload-dash");
        $("#SearchLocation").modal("hide");
        $("#SearchLocation1").modal("hide");
        $("#ageVerify").modal("hide")
         window.location.reload()
        // this.router.navigateByUrl("/");
        // window.location.reload()
      });
    } else {
      this._bs.routerData("reload-dash");
      $("#SearchLocation").modal("hide");
      $("#SearchLocation1").modal("hide");
      $("#ageVerify").modal("hide")
      window.location.reload()
      // window.location.reload()
      // this.router.navigateByUrl("/");
    }
  }

 


 
  popupOpen(mobile, Name,City, StateName,CountryCode, Zip,item?) {
    this.servicesOption = item?.services;
    this.storeMobile = mobile;
    this.selectedStoreAddress = item?.Address?.AddressLine1 + ", " + City + ", " + StateName + ", " + CountryCode + ", " + Zip;
    let weekday = new Date().toLocaleString("en-us", { weekday: "long" });

    if (item["StoreHours"] && item["StoreHours"][weekday]) {
      let a = item["StoreHours"][weekday];
      this.pickopenHour = a;
    }
    if (item["DeliveryHours"] && item["DeliveryHours"][weekday]) {
      this.delOpenHour = item["DeliveryHours"][weekday];
    }

    this.selectedStoreImage = item?.image;
    this.selectedStoreName = Name;

    $("#SearchLocation").modal("show");
    $("#storeHistoryModal").modal("show");
  }

  manageStoreTIme(type: any) {
    if (this.servicesOption.some((s) => s?.includes(type)) && type == "Delivery") {
      return true;
    }

    if (this.servicesOption.some((s) => s?.includes(type)) && type == "Pickup") {
      return true;
    }

    return;
  }

  manageOrderOption(type: any) {
    if (this.servicesOption.some((s) => s.includes(type)) && type == "Delivery") {
      return "Delivery ";
    }

    if (this.servicesOption.some((s) => s.includes(type)) && type == "Pickup") {
      return " Store  Pickup ";
    }

    if (this.servicesOption.some((s) => s.includes(type)) && type == "CurbsidePickup") {
      return " Curbside Pickup";
    }
    return;
  }

  modalClose() {
    $("#storeHistoryModal").modal("hide");

    $("#SearchLocation").modal("show");
  }

  popUpClose() {
    $("#popup1information").modal("hide");

    $("#storeHistoryModal").modal("show");
  }

  closePop() {
    $("#worry_address_searchbar").modal("hide");
  }

  openModal(val) {
    if (val == 2) {
      $("#SearchLocation1").modal("hide");
      $("#SearchLocation").modal("show");
    }
    if (val == 1) {
      $("#worry_address_searchbar").modal("hide");
      $("#SearchLocation").modal("hide");
      $("#SearchLocation1").modal("show");
    }
    if (val == 0) {
      $("#worry_address_searchbar").modal("hide");
      $("#SearchLocation1").modal("hide"); 
      $("#SearchLocation").modal("show");
    }
  }

 
  newStoreHoursFormat(hour, min) {
    if (hour != null && min != null) {
      var newFormatedValue = hour + ":" + min;
      return moment(newFormatedValue, ["HH:mm"]).format("h:mm A");
    }
  }

  selectMailOrderFromHeader(status) {
    $("#herader_location_popup").modal("hide");
    $("#storeHistoryModal").modal("hide");
    if (localStorage.getItem("isPickUpOrder") == status) {
      if (status === "true") {
        $("#SearchLocation").modal("show");
      } else {
        if (this.addressString == null) {
          this.addressString = "";
        }
        $("#SearchLocation1").modal("show");
      }
    } else {
      
      localStorage.setItem("toChangeStatus", status);

      if (status === "true") {
        $("#SearchLocation").modal("show");
      } else {
        if (this.addressString == null) {
          this.addressString = "";
        }
        $("#SearchLocation1").modal("show");
      }
    }
  }

  SelectedStoreName = "";
  storeOpenCloseTimeing(Name) {
    this.selectedStoreName = Name;
    $("#storeHistoryModal").modal("hide");
    $("#storeOpenCloseTimeing").modal("show");
  }



  dilverytime;
  storeDetails: any;
  StoreClosed;
  getStoreDetail() {
    const obj = {
      Id: Number(localStorage.getItem("localStoreId")),
    };

    this.commonService.getStoreDetail(obj).subscribe((res) => {
      this.storeDetails = res["data"];
      let weekday = new Date().toLocaleString("en-us", { weekday: "long" });
      if (this.storeDetails && this.storeDetails["StoreHours"] && this.storeDetails["DeliveryHours"][weekday]) {
        let a = this.storeDetails["StoreHours"][weekday];
        let dilveryHoursObj = this.storeDetails["DeliveryHours"][weekday];
        var currentTime = moment(new Date());
        var StoreOpenTime = a.Open.Hour + ":" + a.Open.Minute;
        var StoreCloseTime = a.Close.Hour + ":" + a.Close.Minute
        var endTime:any
        var beginningTime = moment(StoreOpenTime, 'HH:mm');
        if (StoreCloseTime =='0:0') {
          StoreCloseTime = '24:0'
        }
        if (a.Close.Hour < a.Open.Hour && a.Close.Hour !='0') {
          endTime = moment(StoreCloseTime, 'HH:mm').add(1, 'day')
         }else{
          endTime = moment(StoreCloseTime, 'HH:mm');
         }
                 
        if (currentTime > beginningTime && currentTime < endTime) {
          this.StoreClosed = false;
        } else {
          this.StoreClosed = true;
        }
        if (a) {
          this.dilverytime = dilveryHoursObj;
          localStorage.setItem("storeTiming", JSON.stringify(a));
        }
      }
    });
  }

  storeOpenCloseTimeing1() {
    $("#storeOpenCloseTimeing").modal("hide");
    $("#storeHistoryModal").modal("show");
  }
}
